import {
  ChartPie,
  FileChartPie,
  Component,
  ChevronsLeftRightEllipsis,
  Check,
  House,
  Newspaper,
  Calendar,
  Music,
  TvMinimalPlay,
  Disc,
  AudioLines,
  Video,
  FolderSymlink,
  FolderHeart,
  Folder,
  Star,
  UsersRound,
  Utensils,
  PartyPopper,
  SportShoe,
  LoaderPinwheel,
  Volleyball,
  HandFist,
  Circle,
  CircleSmall,
  Dumbbell,
  Drama,
  Film,
  BookHeart,
  Boxes,
  Handshake,
  MessageSquareQuote,
  FileBox,
  ListClock,
  FileText,
  TextSearch,
  MapPinHouse
} from 'lucide-react';

export function getConstant(path, targetValue) {
  let array = CONSTANT;
  path.split('.').forEach((key) => {
    array = array[key];
  });
  if (array.find((c) => c.value === targetValue)) {
    return array.find((c) => c.value === targetValue);
  } else {
    return '';
  }
}

export const CONSTANT = {
  version: '2.8.3',
  maxImageSize: 20 * 1000000,
  shared: {
    draftTypes: [
      {
        label: 'Brouillon',
        value: true,
        bgColor: 'bg-orange-500'
      },
      {
        label: 'Publié',
        value: false,
        bgColor: 'bg-green-600'
      }
    ],
    imageSizes: [
      {
        label: 'Grande',
        value: 'large'
      },
      {
        label: 'Moyenne',
        value: 'medium'
      },
      {
        label: 'Petite',
        value: 'small'
      }
    ],
    imageHorizontalAlignments: [
      {
        label: 'Gauche',
        value: 'left'
      },
      {
        label: 'Centrée',
        value: 'center'
      },
      {
        label: 'Droite',
        value: 'right'
      }
    ],
    imageVerticalSpaces: [
      {
        label: 'Petite marge',
        value: 'small'
      },
      {
        label: 'Moyenne marge',
        value: 'medium'
      },
      {
        label: 'Grande marge',
        value: 'large'
      }
    ]
  },

  languages: [
    {
      label: 'Français',
      key: 'fr',
      code: 'fr'
    },
    {
      label: 'Anglais',
      key: 'en',
      code: 'gb'
    }
  ],
  superadmin: {
    apps: [
      {
        label: 'Statistiques Globales',
        key: 'analytics',
        icon: FileChartPie
      }
    ]
  },
  analytics: {
    monthsRange: [
      {
        label: '12 derniers mois',
        value: 12
      },
      {
        label: '6 derniers mois',
        value: 6
      },
      {
        label: '3 derniers mois',
        value: 3
      }
    ]
  },
  collectifnode: {
    scopeColor: '#8c91f8',
    enableAnalytics: true,
    apps: [
      {
        label: 'Projets',
        key: 'cnproject',
        icon: Component
      },
      {
        label: 'Audience',
        key: 'analytics',
        icon: ChartPie
      }
    ],
    inProgress: [
      {
        label: 'Projet en cours',
        value: true,
        bgColor: 'bg-yellow-500',
        icon: ChevronsLeftRightEllipsis
      },
      {
        label: 'Projet terminé',
        value: false,
        bgColor: 'bg-green-700',
        icon: Check
      }
    ],
    analytics: [
      {
        key: 'total-page-visits',
        endPoint: 'insights',
        dataKey: 'visits',

        label: 'Nombre de pages visitées',
        displayType: 'summary',
        format: 'number',

        scope: 'collectifnode'
      },

      {
        key: 'unique-user-visits',
        endPoint: 'insights',
        dataKey: 'sessions',

        label: 'Nombre de sessions uniques',
        displayType: 'summary',
        format: 'number',

        info: "Nombre de sessions uniques qui ont visité le site",

        scope: 'collectifnode'
      },

      {
        key: 'average-session-time',
        endPoint: 'insights',
        dataKey: 'average_session_time',

        label: 'Temps de session moyen',
        displayType: 'summary',
        format: 'duration',

        scope: 'collectifnode',
        info: "Temps moyen passé sur le site à chaque visite"
      },

      {
        key: 'visits-by-page',
        label: 'Visites par pages',
        endPoint: 'visit',
        scope: 'collectifnode',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page principale a été visitée"
      },

      {
        key: 'visits-by-sub-page',
        label: 'Détail des visites par projet',
        endPoint: 'visit',
        path: 'realisations',
        scope: 'collectifnode',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page détail d'un projet a été visitée"
      },

      {
        key: 'device-usage',
        label: 'Répartition des appareils utilisés',
        endPoint: 'device',
        scope: 'collectifnode',
        chartType: 'pieChart',
        displayType: 'secondary',
        info: "Répartition des appareils utilisés lors des différentes visites"
      },

      {
        key: 'language-usage',
        label: 'Répartition par langue',
        endPoint: 'languages',
        scope: 'collectifnode',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'browser-usage',
        label: 'Répartition par navigateur',
        endPoint: 'browser',
        scope: 'collectifnode',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'rebound-page',
        label: 'Page de fin de session',
        endPoint: 'page_of_rebound',
        scope: 'collectifnode',
        chartType: 'pieChart',
        displayType: 'secondary',
        info: "Dernières pages visualisées par les utilisateurs avant qu'ils ne quittent le site"
      },

      {
        key: 'day-of-week',
        label: 'Jours des visites',
        endPoint: 'day_of_week',
        scope: 'collectifnode',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'hour-of-session',
        label: 'Heures des visites',
        endPoint: 'average_hours_per_session',
        scope: 'collectifnode',
        chartType: 'pieChart',
        displayType: 'secondary'
      }
    ],

    propertyTypes: [
      {
        label: 'Technologie',
        value: 'cn_technology'
      },
      {
        label: 'Compétence',
        value: 'cn_skill'
      },
      {
        label: 'Type de projet',
        value: 'cn_project_type'
      }
    ]
  },
  prna: {
    apps: [
      {
        label: 'Projets',
        key: 'prnaproject',
        icon: House
      },
      {
        label: 'Actualités',
        key: 'prnacircumstance',
        icon: Newspaper
      }
    ],

    statusTypes: [
      {
        label: 'Brouillon',
        value: 'draft',
        bgColor: 'bg-orange-500'
      },
      {
        label: 'Publié',
        value: 'published',
        bgColor: 'bg-green-700'
      }
    ],
    highlightFilter: [
      {
        label: 'Tous',
        value: 'false'
      },
      {
        label: 'Mis en avant',
        value: 'true'
      }
    ]
  },
  melismes: {
    scopeColor: '#8ac6ff',
    apps: [
      {
        label: 'Évenements',
        key: 'msevent',
        icon: Calendar
      },
      {
        label: 'Programmes',
        key: 'program',
        icon: Music
      },
      {
        label: 'Ressources',
        key: 'resource',
        icon: TvMinimalPlay
      }
    ],
    resourceTypes: [
      {
        value: 'record',
        label: 'Disque',
        icon: Disc
      },
      {
        value: 'audio',
        label: 'Audio',
        icon: AudioLines
      },
      {
        value: 'video',
        label: 'Vidéo',
        icon: Video
      }
    ],
    eventDurations: [
      {
        label: '30 min',
        value: 30
      },
      {
        label: '45 min',
        value: 45
      },
      {
        label: '1 heure',
        value: 60
      },
      {
        label: '1 heure 15 min',
        value: 75
      },
      {
        label: '1 heure 30 min',
        value: 90
      },
      {
        label: '1 heure 45 min',
        value: 105
      },
      {
        label: '2 heures',
        value: 120
      },
      {
        label: '2 heures 15 min',
        value: 135
      },
      {
        label: '2 heures 30 min',
        value: 150
      },
      {
        label: '2 heures 45 min',
        value: 165
      },

      {
        label: '3 heures',
        value: 180
      },
      {
        label: '3 heures 15 min',
        value: 195
      },
      {
        label: '3 heures 30 min',
        value: 210
      },
      {
        label: '3 heures 45 min',
        value: 225
      },
      {
        label: '4 heures',
        value: 240
      }
    ],
    common: {
      statusTypes: [
        {
          label: 'Brouillon',
          value: 'draft',
          bgColor: 'bg-orange-500'
        },
        {
          label: 'Publié',
          value: 'published',
          bgColor: 'bg-green-700'
        }
      ]
    },
    analytics: [
      {
        label: 'Visites par pages',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit',
        scope: 'melismes',
        chartType: 'barChart'
      },
      {
        label: 'Détail des visites par ressource',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/ressources',
        scope: 'melismes',
        chartType: 'barChart'
      },
      {
        label: 'Détail des visites par programme',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/ressources',
        scope: 'melismes',
        chartType: 'barChart'
      },
      {
        label: 'Répartition des appareils utilisés',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'device',
        scope: 'melismes',
        chartType: 'pieChart'
      }
    ]
  },
  solarys: {
    apps: [
      {
        label: 'Ressources internes',
        key: 'syinternalresource',
        icon: FolderSymlink
      },
      {
        label: 'Resources thématiques',
        key: 'syexternalresource',
        icon: FolderHeart
      },
      {
        label: 'Évènements',
        key: 'syevent',
        icon: Calendar
      }
    ],
    resourceTypes: [
      {
        label: 'Fiche pratique',
        value: 'fiche_pratique'
      },
      {
        label: 'Article',
        value: 'article'
      },
      {
        label: 'Outil',
        value: 'outil'
      }
    ],
    publicList: [
      {
        label: 'Grand public',
        value: 'grand_public'
      },
      {
        label: 'Etudiants',
        value: 'etudiants'
      },
      {
        label: 'Collectivité',
        value: 'collectivite'
      },
      {
        label: 'Association étudiante',
        value: 'association_etudiante'
      },
      {
        label: 'Association',
        value: 'associations'
      }
    ],
    propertyTypes: [
      {
        label: 'Public cible',
        value: 'sy_public_list'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ],
    resourceThemes: [
      {
        label: 'Gestion des déchets',
        value: 'gestion_des_dechets'
      },
      {
        label: 'Adaptation',
        value: 'adaptation'
      },
      {
        label: 'Achats responsables',
        value: 'achats_responsables'
      },
      {
        label: 'Réemploi upcycling',
        value: 'reemploi_upcycling'
      },
      {
        label: 'Communication',
        value: 'communication'
      },
      {
        label: 'Restauration',
        value: 'restauration'
      },
      {
        label: 'Mobilités durables',
        value: 'mobilites_durables'
      },
      {
        label: "Économies d'Énergie",
        value: 'economies_denergie'
      },
      {
        label: 'Généralités',
        value: 'generalites'
      },
      {
        label: 'Événementiel',
        value: 'evenementiel'
      },
      {
        label: 'Eco-anxiété',
        value: 'eco_anxiete'
      },
      {
        label: 'Numérique responsable',
        value: 'numerique_responsable'
      },
      {
        label: 'Se former',
        value: 'se_former'
      }
    ],
    cities: [
      {
        label: 'Nantes',
        value: 'nantes'
      },
      {
        label: 'Rennes',
        value: 'rennes'
      }
    ],
    formatList: [
      {
        label: 'Atelier',
        value: 'atelier'
      },
      {
        label: 'Fresque',
        value: 'fresque'
      },
      {
        label: 'Conférence',
        value: 'conference'
      },
      {
        label: 'Table ronde',
        value: 'table-ronde'
      },
      {
        label: 'Débat',
        value: 'debat'
      },
      {
        label: 'Rencontre',
        value: 'rencontre'
      },
      {
        label: 'Webinaire',
        value: 'webinaire'
      },
      {
        label: 'Séminaire',
        value: 'seminaire'
      }
    ],
    themeList: [
      {
        label: 'Achats responsables',
        value: 'achats_responsables'
      },
      {
        label: 'Gestion des déchets',
        value: 'gestion_des_dechets'
      },
      {
        label: 'Mobilités durables',
        value: 'mobilites_durables'
      },
      {
        label: 'Généralités',
        value: 'generalites'
      },
      {
        label: 'Adaptation',
        value: 'adaptation'
      },
      {
        label: 'Réemploi/Upcycling',
        value: 'reemploi_upcycling'
      },
      {
        label: 'Communication',
        value: 'communication'
      },
      {
        label: 'Restauration',
        value: 'restauration'
      },
      {
        label: "Économies d'énergie",
        value: 'economies_denergie'
      },
      {
        label: 'Événementiel',
        value: 'evenementiel'
      },
      {
        label: 'Éco-anxiété',
        value: 'eco_anxiete'
      },
      {
        label: 'Numérique responsable',
        value: 'numerique_responsable'
      },
      {
        label: 'Se former',
        value: 'se_former'
      }
    ]
  },
  chiennoir: {
    availableLanguages: ['fr', 'en'],
    apps: [
      {
        label: 'Tous les projets',
        key: 'cngproject',
        icon: Folder
      },
      {
        label: 'Projets à la une',
        key: 'cngprojecthighlight',
        icon: Star
      },
      {
        label: 'Articles',
        key: 'cngnews',
        icon: Newspaper
      },
      {
        label: 'Audience',
        key: 'analytics',
        icon: ChartPie
      }
    ],
    languages: [
      {
        label: 'Français',
        value: 'fr',
        code: 'fr'
      },
      {
        label: 'Anglais',
        value: 'en',
        code: 'gb'
      }
    ],
    colors: [
      {
        value: 1,
        mainTextColor: '#121212',
        backgroundColor: '#D1D1C8'
      },
      {
        value: 2,
        mainTextColor: '#034AB9',
        backgroundColor: '#C8D5B9'
      },
      {
        value: 3,
        mainTextColor: '#5D2B2E',
        backgroundColor: '#CBCBFF'
      },
      {
        value: 4,
        mainTextColor: '#5E663D',
        backgroundColor: '#F9E784'
      },
      {
        value: 5,
        mainTextColor: '#9D3A02',
        backgroundColor: '#FFE9CE'
      },
      {
        value: 6,
        mainTextColor: '#2F4141',
        backgroundColor: '#DCFFC1'
      }
    ],

    analytics: [
      {
        label: 'Visites par pages',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit',
        scope: 'chiennoir',
        chartType: 'barChart',
        displayType: 'general'
      },
      {
        label: 'Détail des visites par projet',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'visit/path/realisations',
        scope: 'chiennoir',
        chartType: 'barChart',
        displayType: 'general'
      },
      {
        label: 'Répartition des appareils utilisés',
        legend: 'Affichage sur les 12 derniers mois',
        endPoint: 'device',
        scope: 'chiennoir',
        chartType: 'pieChart',
        displayType: 'secondary'
      }
    ]
  },
  kerbouzier: {
    scopeColor: '#C8BD41',
    apps: [
      {
        label: 'Agenda',
        key: 'kbevent',
        icon: Calendar
      }
    ],
    types: [
      {
        label: 'Evénement',
        value: 'event',
        bgColor: 'bg-green-700'
      },
      {
        label: 'Formation, Atelier',
        value: 'course',
        bgColor: 'bg-purple-700'
      },
      {
        label: 'Chantier Participatif',
        value: 'eco_construction',
        bgColor: 'bg-orange-600'
      }
    ],
    subtypes: [
      {
        label: 'Social',
        value: 'social',
        bgColor: 'bg-cyan-900'
      },
      {
        label: 'Tourisme',
        value: 'tourism',
        bgColor: 'bg-pink-900'
      },
      {
        label: 'Jardin',
        value: 'gardening',
        bgColor: 'bg-green-900'
      },
      {
        label: 'Constuction',
        value: 'construction',
        bgColor: 'bg-orange-900'
      }
    ],
    courses: [
      {
        label: 'Paillourte',
        value: 'paillourte'
      },
      {
        label: 'Enduit Terre',
        value: 'enduit_terre'
      },
      {
        label: 'Eco Tourisme',
        value: 'eco_tourisme'
      },
      {
        label: 'Initiation Botanique',
        value: 'initiation_botanique'
      },
      {
        label: 'Atelier Demi Journée',
        value: 'atelier_demi_journee'
      }
    ],
    membership_required: [
      {
        label: 'Adhésion annuelle à 20€',
        value: true,
        bgColor: 'bg-blue-700'
      },
      {
        label: 'Adhésion ponctuelle',
        value: false,
        bgColor: 'bg-amber-700'
      }
    ],
    duplicate_options: [
      {
        label: 'Dupliquer sur 4 semaines',
        value: 4
      },
      {
        label: 'Dupliquer sur 8 semaines',
        value: 8
      },
      {
        label: 'Dupliquer sur 12 semaines',
        value: 12
      },
      {
        label: 'Dupliquer sur 16 semaines',
        value: 16
      }
    ]
  },
  gensdemer: {
    apps: [
      {
        label: 'Soutiens',
        key: 'gdmprospect',
        icon: UsersRound
      }
    ],
    type: {
      with_repossession_rights: 'Avec droit de reprise',
      without_repossession_rights: 'Sans droit de reprise'
    },
    refund_delay: {
      five_years: '5 ans',
      ten_years: '10 ans',
      fiveteen_years: '15 ans'
    }
  },
  bassecour: {
    scopeColor: '#D43A2C',
    apps: [
      {
        label: 'Agenda',
        key: 'bacevent',
        icon: Calendar
      },
      {
        label: 'Actualité',
        key: 'bacnews',
        icon: Newspaper
      },
      {
        label: 'Menu',
        key: 'bacmenu',
        icon: Utensils
      }
    ],
    type: [
      {
        label: 'Concerts',
        value: 'gig'
      },
      {
        label: 'Spectacles',
        value: 'show'
      },
      {
        label: 'Kids',
        value: 'kids'
      },
      {
        label: 'Ateliers et créativité',
        value: 'workshop'
      },
      {
        label: 'Temps forts',
        value: 'key_event'
      },
      {
        label: 'Transitions',
        value: 'transition'
      },
      {
        label: 'Jardinage',
        value: 'gardening'
      },
      {
        label: 'Vie bénévole',
        value: 'volunteers'
      },
      {
        label: 'Scène Ouverte',
        value: 'open_stage'
      },
      {
        label: 'En cuisine',
        value: 'kitchen'
      },
      {
        label: 'Danse & Open Air',
        value: 'open_air'
      }
    ],
    main_tag: [
      {
        label: 'Acteur',
        value: 'actor'
      },
      {
        label: 'Spectateur',
        value: 'spectator'
      }
    ],
    newsTypes: [
      {
        label: 'Portraits-rencontres-histoires',
        value: 'bac_portraits'
      },
      {
        label: 'Vie du tiers-lieu',
        value: 'bac_tiers_lieu'
      },
      {
        label: 'Outils',
        value: 'bac_outils'
      },
      {
        label: "Offres d'emploi",
        value: 'bac_offre_d_emploi'
      },
      {
        label: 'Transitions',
        value: 'bac_transitions'
      }
    ],
    propertyTypes: [
      {
        label: 'Autres tags',
        value: 'bac_other_tags'
      },
      {
        label: 'Lieu',
        value: 'bac_place'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ]
  },
  nouvelleparenthese: {
    scopeColor: '#F4A9BE',
    apps: [
      {
        label: 'Prestations',
        key: 'show',
        icon: PartyPopper
      }
    ],
    propertyTypes: [
      {
        icon: 'pi pi-map',
        type: 'np_location'
      },
      {
        icon: 'pi pi-hashtag',
        type: 'np_theme'
      }
    ]
  },
  banquetceleste: {
    scopeColor: '#544595',
    availableLanguages: ['fr', 'en'],
    apps: [
      {
        label: 'Programmes',
        key: 'program',
        icon: Music
      },
      {
        label: 'Ressources',
        key: 'resource',
        icon: TvMinimalPlay
      },
      {
        label: 'Audience',
        key: 'analytics',
        icon: ChartPie
      }
    ],
    resourceTypes: [
      {
        value: 'record',
        label: 'Disque',
        icon: Disc
      },
      {
        value: 'podcast',
        label: 'Podcast',
        icon: AudioLines
      },
      {
        value: 'video',
        label: 'Vidéo',
        icon: Video
      }
    ],
    programTypes: [
      {
        value: 'concert',
        label: 'Concert'
      },
      {
        value: 'show',
        label: 'Spectacle'
      },
      {
        value: 'festival',
        label: 'Festival'
      },
      {
        value: 'cultural_action',
        label: 'Action culturelle'
      }
    ],
    availableNewsSources: [
      {
        label: 'Télérama',
        value: 'telerama',
        logo: '/press/telerama.svg'
      },
      {
        label: 'Olyrix',
        value: 'olyrix',
        logo: '/press/olyrix.svg'
      },
      {
        label: 'Unidivers',
        value: 'unidivers',
        logo: '/press/unidivers.svg'
      },
      {
        label: 'Baroquiades',
        value: 'baroquiades',
        logo: '/press/baroquiades.webp'
      },
      {
        label: 'BBC Music',
        value: 'bbc-music',
        logo: '/press/bbc.webp'
      },
      {
        label: 'Classica',
        value: 'classica',
        logo: '/press/choc_classica.webp'
      },
      {
        label: 'Concerti magazin',
        value: 'concerti-magazin',
        logo: '/press/concert-magazin.webp'
      },
      {
        label: 'Crescendo',
        value: 'crescendo',
        logo: '/press/crescendo-magazine.webp'
      },
      {
        label: 'Diapason',
        value: 'diapason',
        logo: '/press/Diapason.webp'
      },
      {
        label: 'Early Music World',
        value: 'early-music-world',
        logo: '/press/telerama.svg'
      },
      {
        label: 'Forum Opéra',
        value: 'forum-opera',
        logo: '/press/forumopera.webp'
      },
      {
        label: 'France 3',
        value: 'france-3',
        logo: '/press/france3.webp'
      },
      {
        label: 'France Info',
        value: 'france-info',
        logo: '/press/telerama.svg'
      },
      {
        label: 'France Musique',
        value: 'france-musique',
        logo: '/press/france-musique.webp'
      },
      {
        label: 'Gramophone',
        value: 'gramophone',
        logo: '/press/Gramophone.webp'
      },
      {
        label: "L'Obs",
        value: 'l-obs',
        logo: '/press/nouvelobs.webp'
      },
      {
        label: 'La Croix',
        value: 'la-croix',
        logo: '/press/la-croix.webp'
      },
      {
        label: 'LCI',
        value: 'lci',
        logo: '/press/LCI.webp'
      },
      {
        label: 'Le Monde',
        value: 'le-monde',
        logo: '/press/le_monde.webp'
      },
      {
        label: 'Musikzen',
        value: 'musikzen',
        logo: '/press/Musikzen.webp'
      },
      {
        label: "Musiq'3",
        value: 'musiq-3',
        logo: '/press/Musiq-3.webp'
      },
      {
        label: 'Opéra Magazine',
        value: 'opera-magazine',
        logo: '/press/opera-magazine.webp'
      },
      {
        label: 'Planet Hugill',
        value: 'planet-hugill',
        logo: '/press/hughill.webp'
      },
      {
        label: 'Res Musica',
        value: 'res-musica',
        logo: '/press/res_musica.webp'
      },
      {
        label: 'RTBF',
        value: 'rtbf',
        logo: '/press/RTBF.webp'
      },
      {
        label: 'Scherzo',
        value: 'scherzo',
        logo: '/press/scherzo-magazine.webp'
      }
    ],
    common: {
      statusTypes: [
        {
          label: 'Brouillon',
          value: 'draft',
          bgColor: 'bg-orange-500'
        },
        {
          label: 'Publié',
          value: 'published',
          bgColor: 'bg-green-700'
        }
      ]
    },
    analytics: [
      {
        key: 'total-page-visits',
        endPoint: 'insights',
        dataKey: 'visits',

        label: 'Nombre de pages visitées',
        displayType: 'summary',
        format: 'number',

        scope: 'banquetceleste'
      },

      {
        key: 'unique-user-visits',
        endPoint: 'insights',
        dataKey: 'sessions',

        label: 'Nombre de sessions uniques',
        displayType: 'summary',
        format: 'number',

        info: "Nombre de sessions uniques qui ont visité le site",

        scope: 'banquetceleste'
      },

      {
        key: 'average-session-time',
        endPoint: 'insights',
        dataKey: 'average_session_time',

        label: 'Temps de session moyen',
        displayType: 'summary',
        format: 'duration',

        scope: 'banquetceleste',
        info: "Temps moyen passé sur le site à chaque visite"
      },

      {
        key: 'visits-by-page',
        label: 'Visites par pages',
        endPoint: 'visit',
        scope: 'banquetceleste',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page principale a été visitée"
      },

      {
        key: 'visits-by-sub-page',
        label: 'Détail des visites par programme',
        endPoint: 'visit',
        path: 'programmes',
        scope: 'banquetceleste',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page détail d'un projet a été visitée"
      },
      {
        key: 'visits-by-sub-page-bis',
        label: 'Détail des visites par ressource',
        endPoint: 'visit',
        path: 'ressources',
        scope: 'banquetceleste',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page détail d'un projet a été visitée"
      },

      {
        key: 'device-usage',
        label: 'Répartition des appareils utilisés',
        endPoint: 'device',
        scope: 'banquetceleste',
        chartType: 'pieChart',
        displayType: 'secondary',
        info: "Répartition des appareils utilisés lors des différentes visites"
      },

      {
        key: 'language-usage',
        label: 'Répartition par langue',
        endPoint: 'languages',
        scope: 'banquetceleste',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'browser-usage',
        label: 'Répartition par navigateur',
        endPoint: 'browser',
        scope: 'banquetceleste',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'rebound-page',
        label: 'Page de fin de session',
        endPoint: 'page_of_rebound',
        scope: 'banquetceleste',
        chartType: 'pieChart',
        displayType: 'secondary',
        info: "Dernières pages visualisées par les utilisateurs avant qu'ils ne quittent le site"
      },

      {
        key: 'day-of-week',
        label: 'Jours des visites',
        endPoint: 'day_of_week',
        scope: 'banquetceleste',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'hour-of-session',
        label: 'Heures des visites',
        endPoint: 'average_hours_per_session',
        scope: 'banquetceleste',
        chartType: 'pieChart',
        displayType: 'secondary'
      }
    ],

  },
  jeunedargentre: {
    scopeColor: '#8b90ee',
    apps: [
      {
        label: 'Athlétisme',
        key: 'athletisme',
        icon: SportShoe
      },
      {
        label: 'Basket',
        key: 'basket',
        icon: LoaderPinwheel
      },
      {
        label: 'Football',
        key: 'football',
        icon: Volleyball
      },
      {
        label: 'Gymnastique',
        key: 'gymnastique',
        icon: Dumbbell
      },
      {
        label: 'Tennis',
        key: 'tennis',
        icon: Circle
      },
      {
        label: 'Tennis de Table',
        key: 'tennis-de-table',
        icon: CircleSmall
      },
      {
        label: 'Théâtre',
        key: 'theatre',
        icon: Drama
      },
      {
        label: 'Viet Vo Dao',
        key: 'viet-vo-dao',
        icon: HandFist
      },
      {
        label: 'Cinéma',
        key: 'cinema',
        icon: Film
      },
      {
        label: 'Amicale',
        key: 'amicale',
        icon: BookHeart
      },
      {
        label: 'Association',
        key: 'association',
        icon: UsersRound
      }
    ]
  },
  maisonmousse: {
    scopeColor: '#549970',
    apps: [
      {
        label: 'Évènements',
        key: 'mmevent',
        icon: Calendar
      },
      {
        label: 'Participants',
        key: 'attendees',
        icon: UsersRound
      },
      {
        label: 'Audience',
        key: 'analytics',
        icon: ChartPie
      }
    ],
    tags: [
      {
        label: 'Comprendre',
        value: 'comprendre'
      },
      {
        label: "S'inspirer",
        value: 'inspirer'
      },
      {
        label: 'Imaginer',
        value: 'imaginer'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ],
    analytics: [
      {
        key: 'total-page-visits',
        endPoint: 'insights',
        dataKey: 'visits',

        label: 'Nombre de pages visitées',
        displayType: 'summary',
        format: 'number',

        scope: 'maisonmousse'
      },

      {
        key: 'unique-user-visits',
        endPoint: 'insights',
        dataKey: 'sessions',

        label: 'Nombre de sessions uniques',
        displayType: 'summary',
        format: 'number',

        info: "Nombre de sessions uniques qui ont visité le site",

        scope: 'maisonmousse'
      },

      {
        key: 'average-session-time',
        endPoint: 'insights',
        dataKey: 'average_session_time',

        label: 'Temps de session moyen',
        displayType: 'summary',
        format: 'duration',

        scope: 'maisonmousse',
        info: "Temps moyen passé sur le site à chaque visite"
      },

      {
        key: 'visits-by-page',
        label: 'Visites par pages',
        endPoint: 'visit',
        scope: 'maisonmousse',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page principale a été visitée"
      },

      {
        key: 'visits-by-sub-page',
        label: 'Détail des visites par rendez-mousse',
        endPoint: 'visit',
        path: 'rendez-mousse',
        scope: 'maisonmousse',
        chartType: 'barChart',
        displayType: 'general',
        info: "Nombre de fois que chaque page détail d'un projet a été visitée"
      },

      {
        key: 'device-usage',
        label: 'Répartition des appareils utilisés',
        endPoint: 'device',
        scope: 'maisonmousse',
        chartType: 'pieChart',
        displayType: 'secondary',
        info: "Répartition des appareils utilisés lors des différentes visites"
      },

      {
        key: 'language-usage',
        label: 'Répartition par langue',
        endPoint: 'languages',
        scope: 'maisonmousse',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'browser-usage',
        label: 'Répartition par navigateur',
        endPoint: 'browser',
        scope: 'maisonmousse',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'rebound-page',
        label: 'Page de fin de session',
        endPoint: 'page_of_rebound',
        scope: 'maisonmousse',
        chartType: 'pieChart',
        displayType: 'secondary',
        info: "Dernières pages visualisées par les utilisateurs avant qu'ils ne quittent le site"
      },

      {
        key: 'day-of-week',
        label: 'Jours des visites',
        endPoint: 'day_of_week',
        scope: 'maisonmousse',
        chartType: 'pieChart',
        displayType: 'secondary'
      },

      {
        key: 'hour-of-session',
        label: 'Heures des visites',
        endPoint: 'average_hours_per_session',
        scope: 'maisonmousse',
        chartType: 'pieChart',
        displayType: 'secondary'
      }
    ],
  },
  dejademain: {
    scopeColor: '#000000',
    apps: [
      {
        label: 'Projets',
        key: 'ddproject',
        icon: Handshake
      },
      {
        label: 'Produits',
        key: 'ddproduct',
        icon: Boxes
      }
    ],
    type: [
      {
        label: 'Lumière',
        value: 'light'
      },
      {
        label: 'Décoration',
        value: 'decoration'
      },
      {
        label: 'Mobilier',
        value: 'furniture'
      },
      {
        label: 'Support-partitionnement',
        value: 'support'
      }
    ]
  },
  whisper: {
    scopeColor: '#061736',
    apps: [
      {
        label: 'Avis Client',
        key: 'review',
        icon: MessageSquareQuote
      }
    ],
    inProgress: [
      {
        label: 'Projet en cours',
        value: true,
        bgColor: 'bg-yellow-500',
        icon: ChevronsLeftRightEllipsis
      },
      {
        label: 'Projet terminé',
        value: false,
        bgColor: 'bg-green-700',
        icon: Check
      }
    ]
  },
  caeterra: {
    apps: [
      {
        label: 'Contenus',
        key: 'content',
        icon: Folder
      },
      {
        label: 'Produits',
        key: 'product',
        icon: Boxes
      },
      {
        label: 'Articles',
        key: 'news',
        icon: Newspaper
      }
    ],
    newsTypes: [
      {
        label: 'Article interne',
        value: 'INTERNAL'
      },
      {
        label: 'Article de presse',
        value: 'EXTERNAL'
      }
    ],
    documentTypes: [
      {
        label: "Plaquette Compost'ici",
        value: 'compostici_pdf'
      },
      {
        label: 'Plaquette Terrefertile',
        value: 'terrefertile_pdf'
      }
    ]
  },
  quatrebis: {
    scopeColor: '#FAD022',
    apps: [
      {
        label: 'Évènements',
        key: 'qbevent',
        icon: Calendar
      },
      {
        label: 'Articles',
        key: 'qbnews',
        icon: Newspaper
      },
      {
        label: 'Temps forts / Alumni',
        key: 'qbhighlight',
        icon: FileBox
      },
      {
        label: 'Dates D-code',
        key: 'qbdate',
        icon: ListClock
      },
      {
        label: 'Fichiers',
        key: 'qbfiles',
        icon: FileText
      },
      {
        label: 'Informations dynamiques',
        key: 'qbpills',
        icon: TextSearch
      }
    ],
    type: [
      {
        label: 'Forum',
        value: 'forum'
      },
      {
        label: 'Concerts',
        value: 'concerts'
      },
      {
        label: 'Expositions',
        value: 'expositions'
      },
      {
        label: 'Ateliers & Rencontres',
        value: 'ateliers_rencontres'
      },
      {
        label: 'Festivals',
        value: 'festivals'
      },
      {
        label: 'Marches des créateurices',
        value: 'marches_des_createurices'
      },
      {
        label: 'Autres',
        value: 'autres'
      }
    ],
    selectButtonOptions: [
      {
        label: 'Évènements futurs',
        value: false
      },
      {
        label: 'Évènements passés',
        value: true
      }
    ],
    place: [
      {
        label: 'Bâtiment A',
        value: 'batiment_a'
      },
      {
        label: 'Bâtiment B',
        value: 'batiment_b'
      },
      {
        label: 'Centre Info',
        value: 'centre_info'
      },
      {
        label: 'Café à Projets',
        value: 'cafe_a_projets'
      },
      {
        label: 'Facade du 360',
        value: 'facade_360'
      },
      {
        label: 'Facade du Café à Projets',
        value: 'facade_café_à_projets'
      },
      {
        label: '360',
        value: '360'
      },
      {
        label: 'Hors les murs',
        value: 'hors_les_murs'
      },
      {
        label: 'Salle de spectacle',
        value: 'salle_de_spectacle'
      }
    ],

    propertyTypes: [
      {
        label: 'Thémtique',
        value: 'qb_thematique'
      }
    ],
    highlightType: [
      { label: 'Temps fort', value: 'highlight' },
      {
        label: 'Alumni',
        value: 'alumni'
      }
    ],
    dateType: [
      {
        label: 'Délégué.e du Défenseur des Droits',
        value: 'delegue_defenseur_des_droits'
      },
      {
        label: 'ALTERA',
        value: 'altera'
      },
      {
        label: 'Mouvement contre le Racisme et pour l’Amitié entre les Peuples (MRAP)',
        value: 'mrap'
      },
      {
        label: 'Avocat·es',
        value: 'avocat'
      },
      {
        label: 'D-Code (Clair-Détour)',
        value: 'd_code_cd'
      },
      {
        label: 'D-Code (Karrez)',
        value: 'd_code_k'
      },
      {
        label: 'Autre',
        value: 'autre'
      }
    ],
    selectButtonDCodeOptions: [
      {
        label: 'Rendez-vous futurs',
        value: false
      },
      {
        label: 'Rendez-vous passés',
        value: true
      }
    ],
    filePageList: [
      { label: "L'association (bas de page)", value: 'qb_page_association' },
      { label: 'FRIJ (rectangle jaune)', value: 'qb_page_frij' },
      { label: 'Boite à outils (Espace pro)', value: 'qb_page_boite_a_outils' },
      { label: 'Devenir bénévole (Charte du bénévole)', value: 'qb_page_benevolat' },
      { label: 'JIL (rectangle jaune)', value: 'qb_page_jil' },
      { label: 'Salle de spectacle (rectangle jaune)', value: 'qb_page_salle_spectacle' },
      { label: "Recrutement (offres d'emploi)", value: 'qb_page_recrutement' }
    ],

    pillsType: [
      { label: 'Centre Info', value: 'centre_info' },
      { label: "Bourse d'été", value: 'bourse_d_ete' },
      { label: 'PAEJ', value: 'paej' },
      { label: 'D-Code', value: 'd_code' },
      { label: 'JIL', value: 'jil' },
      { label: 'Café à Projets', value: 'cafe_a_projets' },
      { label: 'Expositions', value: 'expositions' },
      { label: 'Salle de spectacle', value: 'salle_de_spectacle' },
      { label: 'Le Labo', value: 'labo' },
      { label: 'Itinéraire Bis', value: 'itineraire_bis' },
      { label: 'FRIJ', value: 'frij' },
      { label: 'PACC', value: 'pacc' },
      { label: 'Prev En Ville', value: 'prev_en_ville' }
    ]
  },
  diardexpertise: {
    apps: [
      {
        label: 'Articles',
        key: 'news',
        icon: Newspaper
      },
      {
        label: 'Propriétés',
        key: 'defproperty',
        icon: MapPinHouse
      }
    ],
    propertyTypes: [
      {
        label: 'Mots-clés',
        value: 'def_keywords'
      }
    ],
    availableNewsTypes: [
      {
        value: 'conseil',
        label: 'Conseil'
      },
      {
        value: 'actualite',
        label: 'Actualité'
      }
    ]
  }
};
